import React, { useEffect, useState } from 'react';
//import logo from './logo.svg';
import './Growl.css';

import * as model from 'models';

import EventBus from "../../lib/EventBus";
import useLocalStorage from 'lib/useLocalStorage';
import * as notifications from 'lib/notifications';

interface IGrowlNotificationProps {
  value: notifications.IUserNotification;
  onClose: (notification: notifications.IUserNotification) => void;
}

function GrowlNotification(props: IGrowlNotificationProps) {
  const notification = props.value;
  const showMoreVisible = (notification.serverStatusCode || notification.serverStatusMessage);
  const [showMore, setShowMore] = React.useState<boolean>(false);

  return (
    <div className={"growlNotification alert " + notification.cssClass}>
      <button type="button" className="close" onClick={(e) => { e.preventDefault(); props.onClose(notification); }} >&times;</button>
      <p>
        {notification.friendlyHeader && (<><strong>{notification.friendlyHeader}</strong><br /><br /></>)}

        {props.value.friendlyMessage}

        <br /><br />
        {showMoreVisible && (
          <button type="button" className="btn btn-link showMore" onClick={(e) => {e.preventDefault(); setShowMore(!showMore)}}>
            Visa mer...
          </button>
        )}
      </p>
      {showMore && (
        <div>
          <dl>
            <dt>Statuskod</dt><dd>{notification.serverStatusCode}</dd>
            <dt>Serversvar</dt><dd>{notification.serverStatusMessage}</dd>
          </dl>
        </div>
      )}
    </div>
  );
}

function GrowlContainer() {
  //console.log("GrowlContainer");

  const [messages, setMessages] = useLocalStorage<notifications.IUserNotification[]>("userNotifications", []); // [model.parseUserNotification(model.UserNotificationType.Information, "hej hej")]);

  useEffect(() => {
    // Update the document title using the browser API
    const eventBusMessageReceived = (evt: CustomEvent) => {
      //console.log("EventBus got message", data, "messages=", messages);
      var data = evt.detail as notifications.IUserNotification;
      data.removeAt = new Date().getTime() + data.timeout * 1000;
      data.addedAt = new Date().getTime();
      setMessages([...messages, data]);
    };
    
    notifications.on(eventBusMessageReceived);

    return function cleanup() {
      notifications.remove(eventBusMessageReceived);
    };

  }, [messages]);

  // A timer running every second, removing notifications that should not be there anymore.
  useEffect(function() {
    const id = setInterval(function log() {
      const nowTime = new Date().getTime();
      const newMessages = messages
        .filter(x => !x.removeAt  || x.removeAt > nowTime)
        .filter(x => x.addedAt > nowTime - (5*60*1000)); // remove items that are more than 5 minutes old..
      if (messages.length != newMessages.length) {
        setMessages(newMessages);
      }
    }, 100);
    return function() {
      clearInterval(id);
    }
  }, [messages]);

  //console.log("GrowlContainer messages xx", messages);

  return (
    <div className="growlContainer">
      {messages && messages.map((x,i) => {
        return (<GrowlNotification value={x} key={x.id}
          onClose={notification => setMessages(messages.filter(y => y != notification))}
        />)
      })}
    </div>

  );
}

export default GrowlContainer;
